import { Component, Injector } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchDialogComponent } from '@Work/Accounts/proprietary/controls/search-dialog.component';
import { DataService } from '@Core/services/proprietary/data.service';
import { AppService } from '../../../../../core/services/proprietary/app.service';

@Component({
    standalone: false,
    selector: 'supplier-search-dialog',
    templateUrl: './supplier-search-dialog.component.html',
    providers: [DataService]
})
export class SupplierSearchDialogComponent extends SearchDialogComponent {
    constructor(private injector: Injector, private activeModal: NgbActiveModal, public app: AppService) {
        super(injector);
    }

    initialize(): boolean {
        this.parentActiveModal = this.activeModal;
        this.objectType = 'Supplier';
        this.model.title = 'Select Supplier';

        this.model.criteria.Max = this.model.currentOptions.maxRows;

        if (!this.model.criteria.View) {
            this.model.criteria.View = 'Full';
        }

        return true;
    }
}
